import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import AttachmentsLibraryContainer from './attachments_library_container'
import FileViewer from './FileViewer'
import SearchFilter from '../../../../Templates/SearchFilter'
import { imageAttachments, videoAttachments, audioAttachments, pdfAttachments, modelAttachments, currentlyAttachedIcon } from '../../../../Templates/icons'
import { imageExtensions, audioExtensions, videoExtensions, documentExtensions, modelExtensions } from "../../../../Templates/data"
import AtoZAsc from '../../../../../assets/Icons/A-Z_1.png'
import AtoZDesc from '../../../../../assets/Icons/A-Z_2.png'
import AtoZGrayed from '../../../../../assets/Icons/A-Z-Grayed-PH.png'

// Add global keyframes for the animation
const styleSheet = document.createElement('style');
styleSheet.textContent = `
    @keyframes attachmentsModalOpen {
        0% {
            transform: translate(-50%, -50%) scaleY(0) scaleX(0.2);
            opacity: 0;
        }
        100% {
            transform: translate(-50%, -50%) scaleY(1) scaleX(1);
            opacity: 1;
        }
    }
    
    @keyframes attachmentsModalClose {
        0% {
            transform: translate(-50%, -50%) scaleY(1) scaleX(1);
            opacity: 1;
        }
        100% {
            transform: translate(-50%, -50%) scaleY(0) scaleX(0.2);
            opacity: 0;
        }
    }
`;
if (!document.getElementById('attachments-modal-animations')) {
    styleSheet.id = 'attachments-modal-animations';
    document.head.appendChild(styleSheet);
}
function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}


const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: "90%",
        maxWidth: "1500px",
        maxHeight: "90vh",
        margin: "0 auto",
        backgroundColor: theme.palette.background.paper,
        border: '3px solid #808080',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        transformOrigin: 'center center',
        // animation: 'attachmentsModalOpen 0.25s ease-out',
    },
    paperClosing: {
        // animation: 'attachmentsModalClose 0.2s ease-in forwards',
    },
}));

export default function SimpleModal(props) {
    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);
    const [searchText, setSearchText] = React.useState("");
    const [extensionFilter, setExtensionFilter] = React.useState(false);
    const [sortOrder, setSortOrder] = React.useState('grayed');
    const [showOnlyAttached, setShowOnlyAttached] = React.useState(false);
    
    let isAttachmentLibrary = props.callingComponent === "Work Instruction Author Attachments Library"
    
    // Determine the class names based on closing state
    const paperClassName = props.isLibraryClosing 
        ? `${classes.paper} ${classes.paperClosing}` 
        : classes.paper;
    
    // Function to toggle the sort order
    const toggleSortOrder = () => {
        setSortOrder((prevState) =>
            prevState === 'ascending'
            ? 'descending'
            : prevState === 'descending'
            ? 'ascending'
            : 'ascending'
        );
        setExtensionFilter('AtoZ');
    };

    // Function to get the appropriate sorting icon based on sortOrder
    const getSortingIcon = () => {
        const iconStyle = { width: '70px', height: '55px', cursor: 'pointer' };
    
        if (sortOrder === 'ascending') {
            return <img src={AtoZAsc} alt="Ascending" onClick={toggleSortOrder} style={iconStyle} />;
        } else if (sortOrder === 'descending') {
            return <img src={AtoZDesc} alt="Descending" onClick={toggleSortOrder} style={iconStyle} />;
        } else {
            return <img src={AtoZGrayed} alt="Grayed" style={iconStyle} onClick={toggleSortOrder}/>;
        }
    };

    const toggleFilterIcon = (fileExtensions) => {
        if (extensionFilter === fileExtensions) {
          setExtensionFilter(false);
          setSortOrder('grayed');
        } else {
          setExtensionFilter(fileExtensions);
          setSortOrder('grayed');
        }
    };
    
    return (
        <Modal
            open={true}
            onClose={props.closeModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <div style={modalStyle} className={paperClassName}>
                {isAttachmentLibrary ? (
                    <>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '16px',
                            marginBottom: '20px'
                        }}>
                            {/* Title and Close Row */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <div style={{ flex: 1 }} />
                                <h2 id="simple-modal-title" style={{
                                    textAlign: 'center',
                                    color: '#081F5F',
                                    fontSize: '20px',
                                    fontFamily: 'Inter',
                                    fontWeight: '600',
                                    margin: 0
                                }}>
                                    {props.modalTitle}
                                </h2>
                                <div style={{
                                    flex: 1,
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}>
                                    <span style={{
                                        color: '#081F5F',
                                        fontSize: '16px',
                                        fontFamily: 'Inter',
                                        fontWeight: '400'
                                    }}>
                                        Close Window
                                    </span>
                                    <svg className="clickable" onClick={props.closeModal} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="15" cy="15" r="14" stroke="#081F5F" strokeWidth="2" fill="white"/>
                                        <path d="M20.5 9.5L15 15L9.5 9.5L8 11L13.5 16.5L8 22L9.5 23.5L15 18L20.5 23.5L22 22L16.5 16.5L22 11L20.5 9.5Z" fill="#081F5F"/>
                                    </svg>
                                </div>
                            </div>
                            
                        {/* Search and Filters Row */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr auto 1fr',
                            alignItems: 'start',
                            gap: '16px',
                            minHeight: '42px',
                            width: '100%'
                        }}>
                            {/* Left spacer */}
                            <div />
                            
                            {/* Center the search bar */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                                <SearchFilter 
                                    style={{ 
                                        border: "1px solid #808080",
                                        borderRadius: '5px',
                                        background: '#CDCDCD',
                                        width: "320px",
                                        height: '42px',
                                        padding: '0 10px',
                                        boxSizing: 'border-box'
                                    }} 
                                    filterList={(text) => setSearchText(text)} 
                                    placeholder="Search By File Name..." 
                                />
                            </div>
                            
                            {/* Filters on the right */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                gap: '6px',
                                flexWrap: 'wrap'
                            }}>
                                <button
                                    onClick={() => {
                                        setExtensionFilter(null);
                                        setSortOrder('grayed');
                                        setShowOnlyAttached(false);
                                    }}
                                    style={{
                                        width: '85px',
                                        height: '28px',
                                        borderRadius: '4px',
                                        border: '1px solid #081F5F',
                                        background: 'white',
                                        color: '#081F5F',
                                        fontSize: '14px',
                                        fontFamily: 'Inter',
                                        fontWeight: '400',
                                        cursor: 'pointer',
                                        flexShrink: 0
                                    }}
                                >
                                    Show All
                                </button>
                                {getSortingIcon()}
                                {pdfAttachments(() => toggleFilterIcon(documentExtensions), extensionFilter === documentExtensions)}
                                {imageAttachments(() => toggleFilterIcon(imageExtensions), extensionFilter === imageExtensions)}
                                {videoAttachments(() => toggleFilterIcon(videoExtensions), extensionFilter === videoExtensions)}
                                {audioAttachments(() => toggleFilterIcon(audioExtensions), extensionFilter === audioExtensions)}
                                {modelAttachments(() => toggleFilterIcon(modelExtensions), extensionFilter === modelExtensions)}
                                {currentlyAttachedIcon(() => {
                                    setShowOnlyAttached(!showOnlyAttached);
                                    setExtensionFilter(null);
                                    setSortOrder('grayed');
                                }, showOnlyAttached)}
                            </div>
                        </div>
                        </div>
                    </>
                ) : (
                    <div className="flex-apart">
                        <h2 id="simple-modal-title">{props.modalTitle}</h2>
                        <svg className="clickable" onClick={props.closeModal} width="146" height="25" viewBox="0 0 146 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.56299 5.47412C8.10693 5.47412 9.30501 5.88086 10.1572 6.69434C11.0094 7.50781 11.4826 8.43197 11.5767 9.4668H9.96631C9.78369 8.68099 9.41846 8.05843 8.87061 7.59912C8.32829 7.13981 7.56462 6.91016 6.57959 6.91016C5.37874 6.91016 4.40755 7.3335 3.66602 8.18018C2.93001 9.02132 2.56201 10.3135 2.56201 12.0566C2.56201 13.4844 2.89404 14.6437 3.55811 15.5347C4.2277 16.4201 5.2238 16.8628 6.54639 16.8628C7.76383 16.8628 8.69076 16.3952 9.32715 15.46C9.66471 14.9674 9.9165 14.32 10.0825 13.5176H11.6929C11.549 14.8014 11.0731 15.8778 10.2651 16.7466C9.29671 17.7925 7.99072 18.3154 6.34717 18.3154C4.9305 18.3154 3.74072 17.8866 2.77783 17.0288C1.51058 15.8944 0.876953 14.1429 0.876953 11.7744C0.876953 9.97591 1.35286 8.50114 2.30469 7.3501C3.33398 6.09945 4.75342 5.47412 6.56299 5.47412ZM13.5522 5.80615H15.0464V18H13.5522V5.80615ZM20.8237 17.0371C21.8143 17.0371 22.4922 16.6636 22.8574 15.9165C23.2282 15.1639 23.4136 14.3283 23.4136 13.4097C23.4136 12.5796 23.2808 11.9045 23.0151 11.3843C22.5946 10.5653 21.8696 10.1558 20.8403 10.1558C19.9272 10.1558 19.2632 10.5044 18.8481 11.2017C18.4331 11.8989 18.2256 12.7401 18.2256 13.7251C18.2256 14.6714 18.4331 15.46 18.8481 16.0908C19.2632 16.7217 19.9217 17.0371 20.8237 17.0371ZM20.8818 8.85254C22.0273 8.85254 22.9958 9.23438 23.7871 9.99805C24.5785 10.7617 24.9741 11.8851 24.9741 13.3682C24.9741 14.8014 24.6255 15.9857 23.9282 16.9209C23.231 17.8561 22.1491 18.3237 20.6826 18.3237C19.4596 18.3237 18.4884 17.9115 17.769 17.0869C17.0496 16.2568 16.6899 15.1445 16.6899 13.75C16.6899 12.2559 17.069 11.0661 17.8271 10.1807C18.5853 9.29525 19.6035 8.85254 20.8818 8.85254ZM27.647 15.2109C27.6912 15.709 27.8158 16.0908 28.0205 16.3564C28.3968 16.8379 29.0498 17.0786 29.9795 17.0786C30.5329 17.0786 31.0199 16.9596 31.4404 16.7217C31.861 16.4782 32.0713 16.1047 32.0713 15.6011C32.0713 15.2192 31.9025 14.9287 31.5649 14.7295C31.3491 14.6077 30.923 14.4666 30.2866 14.3062L29.0996 14.0073C28.3415 13.8192 27.7826 13.6089 27.4229 13.3765C26.7809 12.9725 26.46 12.4136 26.46 11.6997C26.46 10.8586 26.7616 10.1779 27.3647 9.65771C27.9735 9.13753 28.7897 8.87744 29.8135 8.87744C31.1527 8.87744 32.1183 9.27035 32.7104 10.0562C33.0812 10.5542 33.2611 11.091 33.25 11.6665H31.8389C31.8112 11.3289 31.6922 11.0218 31.4819 10.7451C31.1388 10.3522 30.5439 10.1558 29.6973 10.1558C29.1328 10.1558 28.7039 10.2637 28.4106 10.4795C28.1229 10.6953 27.979 10.9803 27.979 11.3345C27.979 11.7218 28.1699 12.0317 28.5518 12.2642C28.7731 12.4025 29.0996 12.5243 29.5312 12.6294L30.519 12.8701C31.5926 13.1302 32.312 13.382 32.6772 13.6255C33.2583 14.0073 33.5488 14.6077 33.5488 15.4268C33.5488 16.2181 33.2472 16.9015 32.644 17.4771C32.0464 18.0526 31.1333 18.3403 29.9048 18.3403C28.5822 18.3403 27.6442 18.0415 27.0908 17.4438C26.543 16.8407 26.2497 16.0964 26.2109 15.2109H27.647ZM38.9609 8.91064C39.5918 8.91064 40.2033 9.06006 40.7954 9.35889C41.3875 9.65218 41.8385 10.034 42.1484 10.5044C42.4473 10.9526 42.6465 11.4756 42.7461 12.0732C42.8346 12.4827 42.8789 13.1357 42.8789 14.0322H36.3628C36.3905 14.9342 36.6035 15.6592 37.002 16.207C37.4004 16.7493 38.0174 17.0205 38.853 17.0205C39.6333 17.0205 40.2559 16.7632 40.7207 16.2485C40.9863 15.9497 41.1745 15.6038 41.2852 15.2109H42.7544C42.7157 15.5374 42.5856 15.9027 42.3643 16.3066C42.1484 16.7051 41.9049 17.0316 41.6338 17.2861C41.18 17.7288 40.6183 18.0277 39.9487 18.1826C39.589 18.2712 39.1823 18.3154 38.7285 18.3154C37.6217 18.3154 36.6838 17.9142 35.9146 17.1118C35.1453 16.3039 34.7607 15.175 34.7607 13.7251C34.7607 12.2974 35.1481 11.138 35.9229 10.2471C36.6976 9.35612 37.7103 8.91064 38.9609 8.91064ZM41.3433 12.8452C41.2824 12.1978 41.1413 11.6803 40.9199 11.293C40.5104 10.5736 39.827 10.2139 38.8696 10.2139C38.1834 10.2139 37.6079 10.4629 37.1431 10.9609C36.6782 11.4535 36.432 12.0815 36.4043 12.8452H41.3433ZM50.4575 5.80615L52.7568 15.7256L55.5127 5.80615H57.3057L60.0615 15.7256L62.3608 5.80615H64.1704L60.9663 18H59.2314L56.4175 7.88965L53.5869 18H51.8521L48.6646 5.80615H50.4575ZM65.5068 9.15137H67.0259V18H65.5068V9.15137ZM65.5068 5.80615H67.0259V7.49951H65.5068V5.80615ZM69.292 9.10986H70.7114V10.3716C71.132 9.8514 71.5775 9.47786 72.0479 9.25098C72.5182 9.02409 73.0412 8.91064 73.6167 8.91064C74.8784 8.91064 75.7306 9.35059 76.1733 10.2305C76.4168 10.7119 76.5386 11.4009 76.5386 12.2974V18H75.0195V12.397C75.0195 11.8547 74.9393 11.4175 74.7788 11.0854C74.5132 10.5321 74.0317 10.2554 73.3345 10.2554C72.9803 10.2554 72.6898 10.2913 72.4629 10.3633C72.0534 10.485 71.6937 10.7285 71.3838 11.0938C71.1348 11.387 70.9715 11.6914 70.894 12.0068C70.8221 12.3167 70.7861 12.7622 70.7861 13.3433V18H69.292V9.10986ZM79.7012 13.6587C79.7012 14.6105 79.9032 15.4074 80.3071 16.0493C80.7111 16.6912 81.3586 17.0122 82.2495 17.0122C82.9412 17.0122 83.5085 16.7161 83.9512 16.124C84.3994 15.5264 84.6235 14.6714 84.6235 13.5591C84.6235 12.4357 84.3939 11.6056 83.9346 11.0688C83.4753 10.5265 82.908 10.2554 82.2329 10.2554C81.4803 10.2554 80.8688 10.5431 80.3984 11.1187C79.9336 11.6942 79.7012 12.5409 79.7012 13.6587ZM81.9507 8.95215C82.6313 8.95215 83.2013 9.09603 83.6606 9.38379C83.9263 9.5498 84.2279 9.84033 84.5654 10.2554V5.76465H86.0015V18H84.6567V16.7632C84.3081 17.311 83.8958 17.7067 83.4199 17.9502C82.944 18.1937 82.3989 18.3154 81.7847 18.3154C80.7941 18.3154 79.9364 17.9004 79.2114 17.0703C78.4865 16.2347 78.124 15.1252 78.124 13.7417C78.124 12.4468 78.4533 11.3262 79.1118 10.3799C79.7759 9.42806 80.7222 8.95215 81.9507 8.95215ZM91.7456 17.0371C92.7362 17.0371 93.4141 16.6636 93.7793 15.9165C94.1501 15.1639 94.3354 14.3283 94.3354 13.4097C94.3354 12.5796 94.2026 11.9045 93.937 11.3843C93.5164 10.5653 92.7915 10.1558 91.7622 10.1558C90.8491 10.1558 90.1851 10.5044 89.77 11.2017C89.355 11.8989 89.1475 12.7401 89.1475 13.7251C89.1475 14.6714 89.355 15.46 89.77 16.0908C90.1851 16.7217 90.8436 17.0371 91.7456 17.0371ZM91.8037 8.85254C92.9492 8.85254 93.9176 9.23438 94.709 9.99805C95.5003 10.7617 95.896 11.8851 95.896 13.3682C95.896 14.8014 95.5474 15.9857 94.8501 16.9209C94.1528 17.8561 93.071 18.3237 91.6045 18.3237C90.3815 18.3237 89.4103 17.9115 88.6909 17.0869C87.9715 16.2568 87.6118 15.1445 87.6118 13.75C87.6118 12.2559 87.9909 11.0661 88.749 10.1807C89.5072 9.29525 90.5254 8.85254 91.8037 8.85254ZM98.3696 9.10986L100.08 16.1157L101.814 9.10986H103.491L105.234 16.0742L107.052 9.10986H108.546L105.965 18H104.413L102.603 11.1187L100.852 18H99.2993L96.7344 9.10986H98.3696Z" fill="#081F5F" />
                            <path d="M133.5 0C126.587 0 121 5.5875 121 12.5C121 19.4125 126.587 25 133.5 25C140.413 25 146 19.4125 146 12.5C146 5.5875 140.413 0 133.5 0ZM133.5 22.5C127.988 22.5 123.5 18.0125 123.5 12.5C123.5 6.9875 127.988 2.5 133.5 2.5C139.013 2.5 143.5 6.9875 143.5 12.5C143.5 18.0125 139.013 22.5 133.5 22.5ZM137.987 6.25L133.5 10.7375L129.012 6.25L127.25 8.0125L131.738 12.5L127.25 16.9875L129.012 18.75L133.5 14.2625L137.987 18.75L139.75 16.9875L135.262 12.5L139.75 8.0125L137.987 6.25Z" fill="#081F5F" />
                        </svg>
                    </div>
                )}
                {isAttachmentLibrary ? 
                <AttachmentsLibraryContainer
                    previewAttachment={props.previewAttachment}
                    currentAttachments={props.currentAttachments}
                    isAttachmentLibrary={isAttachmentLibrary}
                    isLibraryOpen={props.isLibraryOpen} 
                    libraryOpen={props.handleModalOpen}
                    steps={props.steps}
                    WIPID = {props.WIPID}
                    HighlightID={props.HighlightID}
                    selectedStep={props.selectedStep}
                    currentlySelectedPDFAnnotationID={props.currentlySelectedPDFAnnotationID}
                    currentlySelectedPDFAnnotationAttachment={props.currentlySelectedPDFAnnotationAttachment}
                    isPDFViewer={props.isPDFViewer}
                    saveNewPDFHighLightAttachments={props.saveNewPDFHighLightAttachments}
                    updateStep={props.updateStep}
                    updateSteps={props.updateSteps}
                    onTexturesSaved={props.onTexturesSaved}
                    searchText={searchText}
                    extensionFilter={extensionFilter}
                    sortOrder={sortOrder}
                    showOnlyAttached={showOnlyAttached}
                />
                : 
                <FileViewer
                    closeModal={props.closeModal}
                    fileTypes={props.fileTypes}
                    files={props.files}
                    workInstructionId={props.workInstructionId} />
            }
                </div>
        </Modal>
    );
}
